"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnnotations = void 0;
var _datasetUtils = require("./datasetUtils");
var _annotations = require("./annotations.controllers");
const getAnnotations = props => {
  const {
    offerPrice,
    estimatedPrice
  } = props.data;
  const annotationsOptions = {};
  if ((0, _datasetUtils.isData)(estimatedPrice) && (0, _datasetUtils.isData)(offerPrice)) {
    new _annotations.TwoLinesAnnotationsController(props, annotationsOptions);
  } else if (props.eachPointAnnotation) {
    new _annotations.OneLineEachPointAnnotationController(props, annotationsOptions);
  } else {
    new _annotations.OneLineSummaryAnnotationController(props, annotationsOptions);
  }
  return annotationsOptions;
};
exports.getAnnotations = getAnnotations;